
import { defineComponent } from 'vue'
import { RouterView } from 'vue-router'
import { mapState, mapGetters, useStore } from 'vuex'
import Modal from '@remote/components/modal'
import Dialog from '@remote/components/Dialog.vue'
import Header from '@remote/components/layout/HeaderPlus.vue'
import FooterBar from '@remote/components/layout/FooterBar.vue'
import BTResultPop from '@remote/views/transfer/components/TheTransferTaskItemDetail.vue'
import FileTreeDialog from '@remote/components/file-tree-dialog/FileTreeDialog.vue'

import global from '@remote/store/constantStore'
import { useEnvStore } from '@remote/store/env'
import { useHeziVersionStore } from '@remote/store/version'
import { stat } from '@remote/utils/stat'
import { isOpenInThunderBrower, isLargeViewPort } from '@remote/utils/base'
import { logInfo } from '@remote/utils/logger'
import { toast } from '@remote/utils'
import type { IStoreState as IHeziVersionState } from '@remote/store/version'
import type { IUpdateModalRef } from '@remote/components/business/version/type.d'
import { loginAuth } from '@remote/api/adapter/api-http'
import { SHOW_HEAD_ROUTE_NAME } from '@remote/constant'
import { useUpload } from '@remote/store/upload'

export default defineComponent({
  name: 'App',
  components: {
    RouterView,
    Header,
    Dialog,
    FooterBar,
    BTResultPop,
    FileTreeDialog,
  },
  setup () {
    const store = useStore()
    const hzVersionStore = useHeziVersionStore()
    useUpload()
    return {
      store,
      hzVersionStore,
    }
  },
  computed: {
    ...mapState([
      'dialog',
      'toast',
      'action',
      'queryAuth',
      'panCliFull',
      'connecting',
      'status',
      'privilegeAuth',
      'isNative',
    ]),
    ...mapGetters({
      isMyDevice: 'Devices/isMy',
      isUsed: 'Devices/isUsed',
      isLogin: 'isLogin',
    }),
    show (): boolean {
      return this.dialog.show
    },
    showHead (): boolean {
      // 移动端不展示
      if (!isLargeViewPort() && ['login', 'disks'].includes(this.$route.name)) {
        return false
      }
      return SHOW_HEAD_ROUTE_NAME.includes(this.$route.name as string) && !isOpenInThunderBrower()
    },
    target (): string | undefined {
      return this.store.state.curDeviceRunner?.target
    },
  },
  watch: {
    action (val) {
      if (val === 'logout2' || val === 'close') {
        if (this.isNative) {
          this.store.dispatch('close')
        } else {
          this.store.dispatch('logout', true)
        }
      }
      else if (val === 'check') this.store.commit('dialog', { show: false })
    },
    target (val, oldVal) {
      if (val && oldVal !== val) {
        this.hzVersionStore.checkVersion().then(async (result: IHeziVersionState) => {
          const { hasDeprecatedVersion, versionStore } = result
          if (hasDeprecatedVersion) {
            // 存在废弃的版本，需要强制更新
            console.log('[强制升级]展示强制升级弹窗:', versionStore)
            let $modal: IUpdateModalRef | null = null
            const closeModal = Modal.showVersionUpdateModal({
              from: 'Home',
              closeable: false,
              backdrop: false,
              versionStore,
              getRef: (ref) => $modal = ref,
              onUpdate: (updateList) => {
                console.log('[强制升级]待升级服务列表:', updateList)
                this.hzVersionStore.updateVersion({
                  onSuccess: () => {
                    $modal?.setProgress(100)
                    setTimeout(() => {
                      closeModal()
                      toast('服务升级成功')
                    }, 500)
                  },
                  onError: () => {
                    closeModal()
                    toast('服务升级失败')
                  },
                })
              },
            })
          }
        })
      }
    },
  },
  mounted () {
    if (navigator.onLine) this.checkIsLogin()
  },
  methods: {
    async checkIsLogin () {
      try {
        const query = {
          ...this.$route.query,
        }

        const isLogin = await this.store.dispatch('login', {
          checkRunner: true,
        })
        // 未登录跳转至登录页
        if (!isLogin) {
          if (this.$route.path !== '/close') {
            this.$router.replace({
              path: '/login',
              query: {
                ...query,
              },
            })
          }
        } else {
          // 登录成功
          // 如果走绑定流程，会在getRunner之后开始请求
          logInfo('login')
          loginAuth({ userid: global.userId , platform_name: 'pc_web'})
          // setTimeout(async () => {
          //   await this.store.dispatch('getDeviceInfoWatch')
          //   stat({ action: 'connect_success_page_show' })
          // }, 2000)

          const envStore = useEnvStore()
          if (envStore.userID && envStore.userID !== global.userId) {
            this.store.commit('update', { deleteCompletely: false })
            const State = this.store.state as any
            const user = State.Users.all[query.user_id] || {}
            const name = query.nickname || user.nickName || ''
            const userID = global.user_id || query.user_id || ''
            // logout2 为要求退出登陆，区分action以避免在个人页面中的退出两遍
            this.store.commit('dialog', {
              show: true,
              title: this.isNative ? '登录状态提示' : '登录失败',
              tip: `当前设备已经登录其他迅雷帐号，账号昵称【${name}】账号ID【${userID}】，您可以切换为该迅雷帐号进行下载管理（退出当前帐号后登录该帐号）`,
              okTxt: '切换帐号',
              cancelTxt: '取消',
              action: 'logout2',
              cancel: 'logout2',
            })
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
})
